import { render, staticRenderFns } from "./SectionWrapper.vue?vue&type=template&id=4a74de7d&scoped=true"
import script from "./SectionWrapper.vue?vue&type=script&lang=js"
export * from "./SectionWrapper.vue?vue&type=script&lang=js"
import style0 from "./SectionWrapper.vue?vue&type=style&index=0&id=4a74de7d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a74de7d",
  null
  
)

export default component.exports